import { createSlice } from '@reduxjs/toolkit';

export interface ErrorState {
  errorMessage: string;
}

const initialState: ErrorState = {
  errorMessage: ''
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    handleError(state, action) {
      state.errorMessage = action.payload;
    }
  }
});

export const { handleError } = errorSlice.actions;
export default errorSlice.reducer;
